<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import { getDBEntries, postDBEntry } from "../../api"
    import { isMobile, login, newNotification } from "../store"
    import CardWrapper from "./CardWrapper.svelte"
    import CollapsibleWrapper from "./CollapsibleWrapper.svelte"
    import { onChange, validateField, validateInput } from "./formComponents/helper"
    import Input from "./formComponents/Input.svelte"
    import Cta from "./CTA.svelte"
    import CompanySelect from "./formComponents/CompanySelect.svelte"
    import { initOrderDetails } from "./taskForm/helper"
    import TaskForm from "./taskForm/TaskForm.svelte"
    const dispatch = createEventDispatcher()

    let resetForm = false

    function setCurrentOrderNumber() {
        let filter = {}
        if (orderDetails?.task?.taskType == "towing") {
            filter = {
                "generalDetails.includesTowingTask": true,
            }
            orderDetails.order.generalDetails.includesTowingTask = true
        } else orderDetails.order.generalDetails.includesTowingTask = false

        getDBEntries("order", filter, "-generalDetails.number", 1).then((res) => {
            orderDetails.order.generalDetails.number = res.length ? res[0].generalDetails.number + 1 : 1
        })
    }

    async function createOrder() {
        const validations = [
            { id: "callerName", value: orderDetails?.order.generalDetails.caller.name, validator: validateInput },
            {
                id: "callerTelephone",
                value: orderDetails?.order.generalDetails.caller.telephone,
                validator: validateInput,
            },
            { id: "executingCompany", value: orderDetails?.task.meta.executingCompany, validator: validateInput },
            { id: "contactPerson", value: orderDetails?.task.meta.contactPerson, validator: validateInput },
            {
                id: "shortDescription",
                value: orderDetails?.task.generalDetails.shortDescription,
                validator: validateInput,
            },
            { id: "description", value: orderDetails?.task.generalDetails.description, validator: validateInput },
        ]

        let isValid = true

        for (const { id, value, validator } of validations) {
            // @ts-ignore
            if (!validateField(id, value, validator)) isValid = false
        }
        if (!orderDetails?.order.generalDetails.caller.companyName) {
            newNotification({
                html: "Bitte geben Sie eine Firma an.",
                class: "error",
            })
            return
        }
        if (isValid) {
            const orderRes = await postDBEntry("order", {
                ...orderDetails?.order,
            })
            const order = orderRes.data
            if (!order.id) return
            orderDetails.task.orderId = order.id
            //@ts-ignore
            await postDBEntry("task", {
                ...orderDetails?.task,
                meta: {
                    contactPerson: orderDetails?.task.meta.contactPerson,
                    executingCompany: orderDetails?.task.meta.executingCompany,
                    assignedUsers: orderDetails?.task.meta.assignedUsers,
                    createdBy: {
                        id: $login.user.id,
                        name: `${$login.user.firstName} ${$login.user.lastName}`,
                    },
                    editedBy: [],
                },
            }).then(() => {
                newNotification({
                    html: "Auftrag und Einsatz angelegt.",
                    class: "success",
                })
                orderDetails = initOrderDetails($login)
                resetForm = !resetForm
                setCurrentOrderNumber()
                dispatch("updateOrderList")
            })
        }
    }
    let orderDetails: {
        order: Order
        task: BaseTask
    }
    orderDetails = initOrderDetails($login)
    setCurrentOrderNumber()
    $: if ($login && orderDetails?.task?.meta?.createdBy?.id !== $login.user.id)
        orderDetails.task.meta.createdBy = {
            id: $login.user.id,
            name: `${$login.user.firstName} ${$login.user.lastName}`,
        }
    let selected = orderDetails.task.taskType == "oilSpillRemoval" ? 0 : 1
    function handleTaskTypeChange(event: CustomEvent<{ taskType: BaseTask["taskType"] }>) {
        orderDetails.task.taskType = event.detail.taskType
        selected = orderDetails.task.taskType === "oilSpillRemoval" ? 0 : 1
        setCurrentOrderNumber()
    }
</script>

<form on:submit|preventDefault|stopPropagation="{createOrder}">
    <div class="cols">
        <CardWrapper
            icon="solar_call-chat-outline.svg"
            title="Anrufer"
        >
            <div class="inner-card-wrapper">
                <Input
                    placeholder="Name"
                    id="callerName"
                    onChange="{onChange}"
                    bind:value="{orderDetails.order.generalDetails.caller.name}"
                />
                {#key resetForm}
                    <CompanySelect
                        bind:value="{orderDetails.order.generalDetails.caller.companyName}"
                        onBlur="{() => {}}"
                    />
                {/key}
                <Input
                    placeholder="Telefon"
                    id="callerTelephone"
                    onChange="{onChange}"
                    bind:value="{orderDetails.order.generalDetails.caller.telephone}"
                />
            </div>
        </CardWrapper>
        <CardWrapper
            icon="solar_clipboard-text-outline.svg"
            title="Auftrag & Einsatz anlegen"
        >
            <CollapsibleWrapper
                icon="solar_clipboard-text-outline.svg"
                title="Auftrag"
            >
                <div class="inner-card-wrapper">
                    <Input
                        id="number"
                        type="number"
                        placeholder="Auftragsnummer (Automatisch Vergeben)"
                        disabled="{true}"
                        onChange="{onChange}"
                        value="{orderDetails?.order.generalDetails.number}"
                    />
                </div>
            </CollapsibleWrapper>
            <CollapsibleWrapper
                icon="solar_checklist-outline.svg"
                title="Einsatz"
            >
                {#key resetForm}
                    <TaskForm
                        bind:task="{orderDetails.task}"
                        on:taskTypeChange="{handleTaskTypeChange}"
                        isDashboard="{true}"
                    />
                {/key}
            </CollapsibleWrapper>
        </CardWrapper>
    </div>
    <div
        class="action-buttons"
        style="{$isMobile ? 'justify-content: flex-start;' : ''}"
    >
        <div class="wrapper">
            <Cta
                type="secondaryButton"
                icon="solar_refresh-bold"
                content="{$isMobile ? '' : 'Zurücksetzen'}"
                on:click="{(e) => {
                    e.stopPropagation()
                    e.preventDefault()
                    orderDetails = initOrderDetails($login)
                    resetForm = !resetForm
                    setCurrentOrderNumber()
                }}"
            />
            <Cta
                type="primaryButton"
                icon="solar_add-circle-outline"
                content="Auftrag & Einsatz anlegen"
                on:click
            />
        </div>
    </div>
</form>

<style lang="less">
    @import "../../../assets/variables.less";

    form {
        display: flex;
        flex-direction: column;
        gap: 1.2rem;
        .cols {
            display: flex;
            gap: 2.4rem;
            width: 100%;
            @media @mobile {
                flex-direction: column;
            }
            & > * {
                display: flex;
                flex-direction: column;
                gap: 1.2rem;
            }
            .inner-card-wrapper {
                display: flex;
                flex-direction: column;
                padding: 1.2rem;
                display: flex;
                flex-direction: column;
                gap: 1.2rem;
                width: 100%;
            }
        }
    }

    .action-buttons {
        display: flex;
        justify-content: flex-end;
        .wrapper {
            display: flex;
            gap: 2px;
            border-radius: 12px;
            border: 1px solid var(--grey-200);
            border-right: 0px solid black;
            background: var(--white-100);
        }
    }
</style>
